module.exports = __webpack_public_path__ + "static/media/image_04.bcdcfb41.jpg";